import React from 'react'
import styled from "@emotion/styled";
import {ExampleInstance} from "../ExampleInstance";
import {ExampleInfo} from "./ExampleInfo";

// STYLE ##########################################################

const ExampleContainer = styled(`div`)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// COMPONENT ##########################################################

export const ExampleTwoRowSlider = ({collectionInstance, slidesPerView, SwiperProps}) => {
	const {Swiper, SwiperSlide} = SwiperProps;
	return (
			<ExampleContainer>
				{/* info */}
				<ExampleInfo collectionInstance={collectionInstance} fullWidth={true} />
				
				<Swiper
						slidesPerView={slidesPerView}
						pagination={{
							"clickable": true,
						}}
				>
					{/* example instances */}
	        {collectionInstance.examples.map((example, i) =>
	            <SwiperSlide key={i}><ExampleInstance exampleInstance={example} firstMargin={false} /></SwiperSlide>)}
				</Swiper>
			</ExampleContainer>
	);
}
